import { Chip, Stack } from "@mui/material"
import { isEnabled } from "lib/@components/feature"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { FEATURE_FLAG_OPTIMISER_CONDITIONAL_TRADES } from "../../feature-flag-conditional-trades"
import { CustomSkillIndicator } from "./custom-skill-indicator"

/**
 * Skill chip in the skill map editor. Conditional routing is configured from the
 * edit-mapping drawer, not from the list row.
 */
export function SkillChip({ item }) {
    const conditionalTradesOn = isEnabled(FEATURE_FLAG_OPTIMISER_CONDITIONAL_TRADES)
    const hasConditionals = Array.isArray(item.conditionalTrades) && item.conditionalTrades.length > 0
    const configured = hasConditionals && conditionalTradesOn
    const configuredIcon = getConfiguredIcon(configured)
    const label = item.skillCode ? `${item.skillName} (${item.skillCode})` : item.skillName

    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Chip
                icon={configuredIcon}
                label={label}
                size="small"
                sx={{
                    bgcolor: "grey.500_16",
                    fontWeight: 500,
                    "& .MuiChip-icon": {
                        color: "text.secondary",
                        ml: 0.75,
                        mr: -0.25,
                    },
                }}
                data-cy="skill-chip"
                data-configured={configured || undefined}
            />
            <If value={item.isCustomSkill}>
                <CustomSkillIndicator rate={item.customHourlyRate} />
            </If>
        </Stack>
    )
}

function getConfiguredIcon(configured) {
    if (!configured) return null
    return <Iconify icon="mdi:source-branch" width={14} data-cy="skill-chip-configured-icon" />
}
